import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { siteData } from "../data/mock";

export const TestimonialsSection = () => {
  return (
    <section
      id="testimonials"
      aria-labelledby="testimonials-heading"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="font-mono text-[11px] uppercase tracking-widest text-stone-400 block mb-3">Patient Success</span>
          <h2
            id="testimonials-heading"
            className="text-3xl sm:text-4xl font-semibold text-[#232323] mb-4 tracking-tight"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            Real Results, Real Stories
          </h2>
          <p className="text-lg text-stone-500 leading-relaxed">
            Hear from patients who found lasting relief through our specialized
            treatments.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {siteData.testimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              className="border border-stone-100/80 shadow-sm hover:shadow-md transition-shadow duration-300 rounded-xl bg-white"
            >
              <CardContent className="p-6 lg:p-8">
                <div
                  className="flex items-center gap-1 mb-5"
                  aria-label={`${testimonial.rating} out of 5 stars`}
                  role="img"
                >
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-[#BCA182] fill-[#BCA182]"
                      aria-hidden="true"
                    />
                  ))}
                </div>

                <Quote
                  className="w-8 h-8 text-[#DDE8DA] mb-3"
                  aria-hidden="true"
                />

                <blockquote
                  className={`text-stone-700 leading-relaxed mb-5 ${
                    index === 0 ? "text-lg" : "text-base"
                  }`}
                >
                  &ldquo;{testimonial.quote}&rdquo;
                </blockquote>

                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#F0F4ED] flex items-center justify-center">
                    <span
                      className="text-[#5E8C61] font-semibold text-sm"
                      aria-hidden="true"
                    >
                      {testimonial.author.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="font-medium text-[#232323] text-sm">
                      {testimonial.author}
                    </p>
                    <p className="text-xs text-stone-500">
                      {testimonial.condition}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
